(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentVersionDeleteController',DocumentVersionDeleteController);

    DocumentVersionDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentVersion'];

    function DocumentVersionDeleteController($uibModalInstance, entity, DocumentVersion) {
        var vm = this;

        vm.documentVersion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentVersion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
